import axios from '../utils/axios';

/**
 * Nimbus recording episode (episodes table) — the slice of the wire type
 * the client consumes. live_state is derived server-side:
 * 'live' | 'overdue' | 'idle' | 'stale' | 'processing' | 'finished' | 'failed'.
 */
export interface Episode {
  id: string;
  device_id?: string | null;
  live_state: string;
  start_ts_ms: number;
}

/** Episodes bound to a session, newest first (server orders by start desc). */
export async function getSessionEpisodes(sessionId: string): Promise<Episode[]> {
  return axios.get('/episodes', { params: { testsession_id: sessionId } }).then((res) => res.data);
}
